export const access = {
  changeToVisible: {
    j: false,
    p: true,
    s: true,
    a: true,
  },
  changeToInVisible: {
    j: false,
    p: true,
    s: true,
    a: true,
  },
  createCampaing: {
    j: false,
    p: true,
    s: true,
    a: true,
  },
}
